import React from "react";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";


function BPADocumentsPreview({ documents, svgStyles = {}, isSendBackFlow = false, isHrLine = false, titleStyles }) {
    const { t } = useTranslation();
    return (
        // <Container>
        //   <Row>
        <React.Fragment>
          <div className="row" style={{marginLeft: "2%"}}>
          {documents?.map((document, index) => (
           <div className="col-4" key={document.id || index}>
              {document?.values && document?.values.length > 0 ? document?.values?.map((value, index) => (
                  
                <div key={value?.documentType || index} style={{display:"flex", marginTop:"10px"}}>
                    
                  <a target="_" href={value?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                      <p>
                        <FaFilePdf color="#a10505" style={{ width:'20px', height:'30px'}}/>
                      </p>
                    </a>
                    <p style={{ margin: '2px 0' }}>{t(value?.additionalDetails?.title)}</p>
                  </div>
             
              )) : !(window.location.href.includes("citizen")) && <div><p>{t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")}</p></div>}
            
            </div>
       
        ))}
        </div>
        </React.Fragment>
      // </Row>
      // </Container>
      
    );
}

export default BPADocumentsPreview;
